import { gql } from 'shared/types/layoutcreator'

// TODO: Rename to contain "admin" in the name
export const CHECK_AUTH = gql(/* GraphQL */ `
  query checkAuth {
    checkAuth
  }
`)

export const GET_ADMIN_PROJECTS = gql(/* GraphQL */ `
  query getAdminProjects($groupId: String!) {
    getAdminProjects(groupId: $groupId) {
      id
      name
      pagePreviews {
        ...PagePreviewsFields
      }
      deleted
    }
  }
`)

export const GET_DB_SNAPSHOT = gql(/* GraphQL */ `
  query getDbSnapshot($groupId: String!) {
    getDbSnapshot(groupId: $groupId)
  }
`)

export const GET_PROJECT_DETAILS = gql(/* GraphQL */ `
  query getProjectDetails($projectId: String!) {
    getProjectDetails(projectId: $projectId) {
      name
      groupId
      pagesCount
    }
  }
`)

export const GET_EXPORT_DATA = gql(/* GraphQL */ `
  query getExportDocument($taskId: String!) {
    getExportDocument(taskId: $taskId) {
      documentId
      taskId
      isStarted
      isFinished
      isSucceeded
      url
    }
  }
`)


export const GET_KPI = gql(/* GraphQL */ `
  query getKpi($minPagesCount: Int!) {
    getKpi(minPagesCount: $minPagesCount) {
      pagesCreated
      pagesExported
      projectsCreated
      projectsCreatedWithMinPagesCount
      activeGroups
    }
  }
`)
